
export function getServiceDocumentUrl(mimirEndpoint: string) {
  return mimirEndpoint + '/api/v1';
}
